import { ArrowUpOutlined, MinusOutlined } from '@ant-design/icons'
import { Button, Col, Row, Text } from '@qonsoll/react-design'
import { useCallback, useMemo } from 'react'

import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

const RewardSortMenu = (props) => {
  const { filteredData, setFilteredData } = props

  /* Getting translations instance */
  const { t } = useTranslations()

  /* Fields for sorting */
  const sortKeys = useMemo(
    () => ({
      Sno: 'sno',
      Name: 'name',
      Store: 'store',
      Redeemed: 'redeemed',
      Reward: 'reward',
      Points: 'points',
      'Creation Date': '_createdAt'
    }),
    []
  )

  /* Sort button click action */
  const sortButtonClick = (key) => {
    const { orderBy } = filteredData
    const [field, direction] = orderBy || []
    const newSortField = sortKeys[key]
    if (field === newSortField) {
      setFilteredData({
        ...filteredData,
        orderBy: [newSortField, direction === 'asc' ? 'desc' : 'asc']
      })
    } else {
      setFilteredData({
        ...filteredData,
        orderBy: [newSortField, 'asc']
      })
    }
  }

  /* Getting sort icon for field */
  const getSortIcon = useCallback(
    (key) => {
      const field = sortKeys[key]
      const { orderBy } = filteredData
      const [currentSortField, direction] = orderBy || []

      if (field === currentSortField) {
        return direction === 'asc' ? (
          <ArrowUpOutlined />
        ) : (
          <ArrowUpOutlined rotate={180} />
        )
      } else {
        return <MinusOutlined />
      }
    },
    [filteredData, sortKeys]
  )

  /* Clearing sort */
  const onClearSort = () => setFilteredData({ ...filteredData, orderBy: null })
  return (
    <>
      <Row>
        <Col pl="0px">
          {Object.keys(sortKeys).map((key, index) => (
            <Row mb="8px" key={index}>
              <Col py="0px">
                <Text>{key}</Text>
              </Col>
              <Col py="0px" cw={1}>
                <Button
                  icon={getSortIcon(key)}
                  size="small"
                  type="text"
                  onClick={() => sortButtonClick(key)}
                />
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
      <Row>
        <Col h="center">
          <Button onClick={() => onClearSort()} size="small">
            {t('Clear sort')}
          </Button>
        </Col>
      </Row>
    </>
  )
}

RewardSortMenu.propTypes = {
  filteredData: PropTypes.object,
  setFilteredData: PropTypes.func
}

export default RewardSortMenu
